<template>
  <div :class="info">
    <K-Loading :Loading="Loading" v-if="!datas"></K-Loading>
    <div v-else>
      <!-- logo -->
      <div class="logo"><img :src="datas.business.logo"></div>

      <!-- 焦点图 -->
      <div class="MainBox">
        <viewer @inited="inited" ref="viewer">
          <div class="swiper-container banner">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-if="datas.focus && datas.focus_pics_is_show == 1"
                v-for="(item, index) in datas.focus" v-bind:key="index">
                <a :href="item.url" target="_blank"><img :src="item.img"></a>
              </div>
            </div>
          </div>
        </viewer>
      </div>

      <!-- 标题 -->
      <div class="title content">
        <p class="title-en"><i>Anti-counterfeiting</i><i>verification</i><i>of</i><i>{{info.enName}}</i><i>Products</i></p>
        <p v-if="lan == 'cn'" class="title-cn no-copy">{{info.name}}产品溯源防伪验证系统</p>
      </div>

      <!-- 提示信息 -->
      <div class="text content">
        <p>Please enter here the code displayed on</p>
        <p>the packaging of your {{info.enName}} product：</p>
      </div>
      <div v-if="lan == 'cn'" class="hint content">
        <p>请揭开{{info.name}}产品防伪标签刮刮银</p>
        <p>并在此处输入6位数字防伪码:</p>
      </div>

      <!-- 表单 -->
      <div class="anti-fake-input content">
        <input v-if="lan == 'cn'" v-model="vcode" @keyup.enter="CodeVerify" maxlength="6" placeholder="在此输入防伪码" />
        <input v-else v-model="vcode" @keyup.enter="CodeVerify" maxlength="6"
          placeholder="Enter the anti-counterfeiting code here" />
      </div>
      <div class="anti-fake-button content">
        <button @click="CodeVerify"><i>Verify</i>{{ lan == 'cn' ? '验 证' : '' }}</button>
      </div>

      <!-- 查询结果 -->
      <section class="result-box" v-if="status === 200">

        <!-- 首次查询反馈 -->
        <section class="box box-one text-top" v-if="status === 200 && count === 1">
          <div>
            <div class="return-box text-top">
              <p class="return-title"><img src="/static/images/Normal20/icon-04.png"><span>CONGRATULATIONS!</span></p>
              <p class="return-text text-top">This Code is valid. You have purchased an ORIGINAL {{info.enName}} product.</p>
              <p class="return-text">{{info.enName}} Pharmaceuticals(Lao) Co., LTD. (referred to as {{info.enName}} Pharmaceuticals),
                located in Vientiane, the capital of Laos with 25,000 square meters self-built factory park, the park has
                high-end pharmaceutical international standard GMP production workshop and other perfect supporting
                facilities; The company has gathered a large number of international high-end talents, including medical
                and technical talents from India and China and has a large amount of medical technological reserve. {{info.enName}}
                Pharmaceutical is a global leader in global generic drugs.</p>
              <p class="return-text">Thank you for confirming with {{info.enName}}. {{info.enName}} wishes you good health!</p>
            </div>
            <div class="return-box" v-if="lan == 'cn'">
              <p class="return-text text-top">恭喜!</p>
              <p class="return-text">此验证码是有效防伪码，感谢您选择了{{info.name}}公司正品！</p>

              <!-- 大熊 -->
              <p v-if="[100010370].includes(info.id)">
                大熊制药是老挝国家正规的化学制药企业之一，坐落于老挝国家首都（万象市）。大熊制药将坚持以科学发展观为指导，秉承“人类健康至上，质量永远第一”的企业宗旨，自建厂初开始推行全面质量管理（TQM），建立了完善有效的质量管理体系，生产过程的各个环节均按照GMP标准执行，同时公司先后引进了多套具有国际先进水平的生产设备和检测仪器，拥有全自动颗粒制造及包装设备、软胶囊制造设备、硬胶囊填充设备、压片机设备、胶囊包装设备及高效液相色谱仪等先进设备，将公司建设成为紧密型、高效能、可持续的国内外领先世界一流的现代制药集团。
              </p>

              <!-- 其它 -->
              <p v-else class="return-text">
                {{info.name}}制药(老挝)有限公司（简称{{info.name}}制药)，坐落于老挝首都万象，拥有25,000平的自建厂房园区，园区内拥有高端制剂国际标的GMP生产车间和其他完善的配套设施；公司聚集了大量国际高端人才包括来自印度和中国的医药技术人才，储备了大量的医药技术，是全球仿制药的领导者！
              </p>

              <p class="return-text">感谢您使用{{info.name}}产品防伪验证系统。</p>
              <p class="return-text">{{info.name}}公司祝您早日康复！</p>
            </div>
          </div>
        </section>

        <!-- 第二次查询反馈 -->
        <section class="box box-two" v-if="status === 200 && count === 2">
          <div>
            <div class="error-box">
              <p class="error-title">
                <img src="/static/images/Normal20/icon-09.png">
                <span>Warning{{ lan == 'cn' ? ' 警告' : '' }}!!</span>
              </p>
              <p class="error-text text-top">You are the <i class="count-en">{{count}}nd</i> verifier of this code. The1st time to
                query:<i class="first-query">{{ first_time }}</i> If the <i>1st</i> verification occurs before you
                <strong>beware of fake products!</strong>
              </p>

              <template v-if="lan == 'cn'">
                <p class="error-text">您本次是此防伪码的第<i class="count-cn">{{ count }}</i>次验证者。该防伪码已于<i class="first-query">{{
                  first_time
                }}</i>第一次被验证。</p>
                <p class="error-text text-top"><strong>如果第<i>1</i>次验证发生在您之前，请谨防假冒!</strong></p>
              </template>
            </div>
          </div>
        </section>


        <!-- 多次查询反馈 -->
        <section class="box box-three" v-if="status === 200 && count >= 3">
          <div>
            <div class="error-box">
              <p class="error-title">
                <img src="/static/images/Normal20/icon-09.png">
                <span>Warning{{ lan == 'cn' ? ' 警告' : '' }}!!</span>
              </p>
              <p class="error-text text-top">You are the <i class="count-en">{{count}}nd</i> verifier of this code. <strong>If
                  the</strong> <i>1st</i> <strong>verification occurs before you,</strong> <i>beware of fake products</i>
                !</p>
              <template v-if="lan == 'cn'">
                <p class="error-text">你本次是此防伪码的第 <i class="count-cn">{{count}}</i> 次验证者。<strong>如果第 1
                    次验证发生在你之前,</strong><i>请谨防假冒伪劣产品!</i></p>
              </template>
              <p class="error-text text-padding">This code has been verified too many times and may have been illegally
                used. It is suspected as fake product. <i>Do not Purchasing and Taking it.</i> </p>
              <template v-if="lan == 'cn'">
                <p class="error-text">此防伪码已被系统验证多次，可能已被非法使用。<strong>此产品涉嫌假冒，</strong><i>禁止购买和服用!</i></p>
              </template>
            </div>
          </div>
        </section>

        <!-- 导航切换 -->
        <section class="box">
          <div class="nav-box">
            <ul v-for="(item, index) in navList" :key="index" class="nav-list" @click="navIndex = index">
              <li class="nav-list-img"><img :src="`/static/images/Normal20/${item.icon}`"></li>
              <template v-if="lan == 'cn'">
                <li class="nav-list-title no-copy">{{ item.name_cn }}</li>
                <li class="nav-list-text no-copy">{{ item.name_en }}</li>
              </template>
              <template v-else>
                <li class="nav-list-text no-copy" style="padding-top: 12rem">{{ item.name_en }}</li>
              </template>
            </ul>
          </div>
        </section>

        <!-- 验证记录 -->
        <section class="scan-box" v-if="navIndex === 0">

          <!-- 首次查询记录 -->
          <section class="box first-check" v-if="count === 1 && recordList.length">
            <div class="record-title">First Verilfy Info {{ lan == 'cn' ? '首次验证信息' : '' }}</div>
            <div class="record-box first-record-box">
              <ul>
								<li class="record-key">Time {{lan=='cn'?'验证时间':''}}</li>
								<li class="record-value">{{recordList[0].time}}</li>
							</ul>
							<ul>
								<li class="record-key">Date {{ lan=='cn'?'验证日期':'' }}</li>
								<li class="record-value">{{recordList[0].date}}</li>
							</ul>
							<ul>
								<li class="record-key">Country {{ lan=='cn'?'所处国家':'' }}</li>
								<li class="record-value">CHINA</li>
							</ul>
							<ul>
								<li class="record-key">IP Address {{ lan=='cn'?'所处IP地址':'' }}</li>
								<li class="record-value">{{recordList[0].address}}</li>
							</ul>
            </div>
          </section>

          <!-- 多次查询记录 -->
          <section class="box many-check" v-if="count >= 2 && recordList.length">
            <div class="record-list">
              <ul class="record-many-box record-many-title">
                <li>
                  <p>Verify Times</p>
                  <p v-if="lan=='cn'">验证次数</p>
                </li>
                <li>
                  <p>Verify Time</p>
                  <p v-if="lan=='cn'">验证日期</p>
                </li>
                <li>
                  <p>Country & IP</p>
                  <p v-if="lan=='cn'">国家和IP地址</p>
                </li>
              </ul>
              <ul class="record-many-box record-many-title" v-for="(item, index) in recordList">
                <li>
                  <p>{{ page * pageSize - (index===0?1:0) }} st time</p>
                  <p v-if="lan=='cn'">第 {{ page * pageSize - (index===0?1:0) }} 次</p>
                </li>
                <li>
                  <p>{{item.date}}</p>
                  <p>{{item.time}}</p>
                </li>
                <li>
                  <p>CHINA</p>
                  <p>{{item.address}}</p>
                </li>
              </ul>

            </div>
            <div class="record-footer">
              {{ lan=='cn'?`Total ${totalCount} times 共 ${totalCount} 條`:`Total ${totalCount} times` }}
            </div>
            <div>
              <ul class="record-many-page">
                <li class="prev" @click="pageUp('prev')" v-text="'<'"></li>
                <li class="page">1</li>
                <li class="next" @click="pageUp('next')" v-text="'>'"></li>
              </ul>
            </div>
          </section>

          <!-- 多次查询记录提示 -->
          <section class="box" v-if="count >= 2">
            <div>
              <div class="error-box">
                <p class="error-text"><strong>Please check the above verification information carefully!</strong></p>
                <p class="error-text text-padding"><i>Do not Purchase the verified Product by others！</i></p>
                <template v-if="lan == 'cn'">
                  <p class="error-text"><strong>请务必仔细核对上述所有验证信息!</strong></p>
                  <p class="error-text text-padding"><i>请勿购买已被他人验证的产品，谨防假冒!</i></p>
                </template>
              </div>
            </div>
          </section>

        </section>

        <!-- 产品信息 -->
        <section class="box product-box" v-if="navIndex === 1">
          <div class="record-title">Product Info {{ lan == 'cn' ? '产品信息' : '' }}</div>
          <div class="record-img"><img :src="datas.product.img"></div>
          <div class="record-box" v-if="datas.product">
            <ul v-for="(value, index) in datas.product.attribute" :key="index">
              <li class="record-key">{{ lan == 'cn' ? value.name : (value.enName || value.name) }}</li>
              <li class="record-value">{{ lan == 'cn' ? value.value : (value.enValue || value.value) }}</li>
            </ul>
          </div>
        </section>

        <!-- 联系方式 -->
        <section class="box contact-box" v-if="navIndex === 2">
          <div class="company-info">
            <ul>
              <img class="company-icon" src="/static/images/Normal20/icon-05.png" />
              <li class="company-title">Phone{{ lan == 'cn' ? '电话' : '' }}:</li>
              <li class="company-text">{{ datas.business.linkphone }}</li>
            </ul>
            <ul>
              <img class="company-icon" src="/static/images/Normal20/icon-06.png" />
              <li class="company-title">Email{{ lan == 'cn' ? '邮箱' : '' }}:</li>
              <li class="company-text">{{info.email}}</li>
            </ul>
            <ul>
              <img class="company-icon" src="/static/images/Normal20/icon-07.png" />
              <li class="company-title">Address{{ lan == 'cn' ? '地址' : '' }}:</li>
              <li class="company-text">{{ datas.business.baddress }}</li>
            </ul>
            <ul>
              <img class="company-icon" src="/static/images/Normal20/icon-08.png" />
              <li class="company-title">Offical Website {{ lan == 'cn' ? '官网' : '' }}</li>
              <li class="company-text">www.{{info.website}}</li>
            </ul>
          </div>
        </section>

        <!-- 底部菜单 -->
        <footer>
          <div class="footer-copyright">Copyright © 2023 {{info.enName}} {{info.right}}</div>
          <div v-if="lan == 'cn'" class="footer-company">版权所有2023 | {{info.name}}制药（老挝）有限公司</div>
          <a v-if="[100010370].includes(info.id)" class="footer-company" target="_blank" :href="`https://${info.website}`">https://{{info.website}}</a>
        </footer>

      </section>

      <!-- 错误查询反馈 -->
      <section class="box error-box" v-if="status === 500">
        <div class="error-box margin-bottom">
          <p class="error-title">
            <img src="/static/images/Normal20/icon-09.png">
            <span>Warning{{ lan == 'cn' ? ' 警告' : '' }}!!</span>
          </p>
          <p class="error-text text-top">This Code can not match with {{info.enName}} verify system. <i>It is NOT valid.</i> Please
            check for typing errors and then try again!</p>
          <p v-if="lan == 'cn'" class="error-text text-padding"><i>此验证码与{{info.name}}公司产品防伪验证系统不相匹配，属无效防伪码。请检查是否存在输入错误并再试一次！</i></p>
        </div>
      </section>

    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Swiper from 'swiper'
import Loading from '@/components/Loading.vue'
import Music from '@/components/Music.vue'
import mixin from '../mixins/mixin.js'
import { getUserLocation } from '../hook/common.js'
export default {
  name: 'Normal01',
  components: {
    'K-Loading': Loading,
    'K-Music': Music
  },
  mixins: [mixin],
  data() {
    return {
      lan: 'cn',
      page: 1,
      pageSize: 2,
      totalPage: 1,
      totalCount: 0,
      status: -1,
      vcode: null,
      hintTxt: null,
      count: 0,
      first_time: '',
      queryContent: null,
      navIndex: 0,
      navList: [{
        icon: "icon-01.png",
        name_cn: "验证记录",
        name_en: "Verify History"
      }, {
        icon: "icon-02.png",
        name_cn: "商品信息",
        name_en: "Product Info"
      }, {
        icon: "icon-03.png",
        name_cn: "联系我们",
        name_en: "Contact Us"
      }],
      recordList: [],
      infoObj: {
        100010304:{
          id: 100010304,
          img: 'nav-banner',
          name: '卢修斯',
          enName: 'Lucius',
          email: 'info@Lucius.la',
          website: 'Lucius.la',
          right: 'pharmaceuticals (Lao) Co., Ltd',
        },
        100010370:{
          class: 'daxiong',
          id: 100010370,
          img: 'dx-nav-banner',
          name: '大熊',
          enName: 'BigBear',
          email: 'info.bigbearpharma1@gmail.com',
          website: 'www.bigbearpharma.com',
          right: 'Pharmaceutical Co., Ltd',
        }
      },
      info: {}
    }
  },
  created() {
    const customWidth = 750; //设计图宽度
    const winWidth = document.body.offsetWidth;
    const initSize = winWidth / customWidth;
    const html = document.getElementsByTagName('html')[0];
    html.style.fontSize = initSize + 'px';
    this.lan = localStorage.getItem("wwm_language") || 'cn';
    document.querySelector('body').setAttribute('style', 'background-color:#FFFFFF');
    this.info = this.infoObj[localStorage.getItem("wwmxt_Rootid") || 100010304]

    //判断是演示还是真实码标
    if (this.$route.query.type == "demo") {
      const pid = this.$route.query.pid; //产品ID
      const rid = this.$route.query.rid; //企业ID
      this.GetDemoDatas(pid, rid);  //获取演示模板信息
    } else {
      this.GetDatas();  //获取码标信息
    }
  },
  watch: {
    datas(nval) {
      if (nval) {
        if (nval.product && nval.product.attribute.length) {
          nval.product.attribute.forEach(val => {
            if (val.key) {
              const ix = val.key.indexOf('.');
              val.cnName = ix != -1 ? val.key.substring(0, ix) : val.key;
              val.enName = ix != -1 ? val.key.substring(ix + 1, val.key.length) : '';
              val.name = val.key.replace(/\./, '');
            }
            if (val.value) {
              const ix = val.value.indexOf('.');
              val.cnValue = ix != -1 ? val.value.substring(0, ix) : val.value;
              val.enValue = ix != -1 ? val.value.substring(ix + 1, val.value.length) : '';
              val.value = val.value.replace(/\./, '');
            }
          })
        }

        this.$nextTick(function () {
          new Swiper('.banner', {
            autoplay: {
              delay: 3000
            },
            autoHeight: true, //高度随内容变化
            loop: true, //可选选项，开启循环
          })
        })

      }
    }
  },
  methods: {
    inited(viewer) {
      this.$viewer = viewer
    },
    PreviewImgs() {
      this.$viewer.show();
      this.$viewer.update();
    },
    getSignUrl() {
      var signLink = ''
      var ua = navigator.userAgent.toLowerCase();
      if (/iphone|ipad|ipod/.test(ua)) {
        signLink = `https://lj.oid.plus/?${this.code}`;
      } else {
        signLink = location.href
      }
      return signLink;
    },
    getWXInfo: function () {
      return new Promise((resolve, reject) => {
        $.ajax({
          type: "post",
          url: "https://sale.oid.plus/v1/wechat-public/js-ticket",
          dataType: 'json',
          data: {
            url: this.getSignUrl(),
            syid: "100010034"
          },
          success: function (res) {
            if (res.code == 200) {
              resolve(true);
              wx.config({
                debug: false,
                appId: res.data.appId,
                timestamp: res.data.timestamp,
                nonceStr: res.data.nonceStr,
                signature: res.data.signature,
                jsApiList: ['scanQRCode', "getLocation"],
                openTagList: ['wx-open-launch-weapp']
              });
            } else {
              resolve(false);
            }
          },
          error: function (err) {
            resolve(false);
          }
        });
      })
    },
    async getLocation (){
      await this.getWXInfo()
      const res = await getUserLocation();
      let position = {};
      if (res.code == 200) {
        position = {
          address: res.data.address,
          country: res.data.address_component.country, //国家
          province: res.data.address_component.province, //省
          city: res.data.address_component.city, //市
          district: res.data.address_component.district, //区
          location: res.data.location.lng+','+res.data.location.lat //经纬度
        }
      }
      return position;
    },
    async addQueryRecord() {
      const data = await this.getLocation();
      const params = {
        is_verify: 1,
        type: 1, //0-ip,1-定位
        code: this.code,
        province: data.province || '', //省
        city: data.city || '', //市
        district: data.district || '', //区
        address: data.address || '', //详细地址
        company_id: this.datas.business.rootid, //企业id
        product_name: this.datas.product.name, //产品名称
        location: data.location || '', //经纬度
        status: this.status === 200?1:0, //状态
        scan_number: this.datas.scan_count || '', //扫码次数
        query_number: this.count, //查询次数
      }
      axios.post(this.GetServerUrl(1) + "addQueryRecord",params);
    },
    CodeVerify() {
      if (!this.vcode) return;
      axios.get(this.GetServerUrl(1) + "queryVerify/" + this.code + "/" + this.vcode)
        .then((response) => {
          var json = response.data;
          if (json.code == 200) {
            const data = json.meta;
            this.status = 200;
            this.count = data.query_count;
            this.first_time = data.query_first_time;
            this.GetRecord();
            this.addQueryRecord();
          }
        }).catch((error) => {
          this.status = 500;
          this.count = this.datas.query_count;
          this.addQueryRecord();
        })
    },
    pageUp(e){
			//上一页
			if(e === 'prev' && this.page > 1){
				this.page--;
				this.GetRecord();
			}

			//下一页
			if(e === 'next' && this.page < this.totalPage){
				this.page++;
				this.GetRecord();
			}
		},
    GetRecord() {
      axios.get(this.GetServerUrl(1) + "queryVerifyList/" + this.code + "/" + this.page+"?pageSize="+ this.pageSize)
        .then((response) => {
          let res = response.data.meta;
          res.data.map(item=>{
						const date_time = item.created_at.split(' ');
            item.date = date_time[0];
            item.time = date_time[1];
            return item;
          })
          this.recordList = res.data;
          this.totalPage = res.last_page;
          this.totalCount = res.total;
        }).catch(function (error) {
          console.log(error)
        })
    },
  }
}
</script>
<style scoped lang="scss">
/* 禁止长按保存图片 */
img {
  pointer-events: none;
}

/*禁止复制*/
:not(input, textarea) {
  -webkit-touch-callout: none;
  /*系统默认菜单被禁用*/
  -webkit-user-select: none;
  /*webkit浏览器*/
  -khtml-user-select: none;
  /*早期浏览器*/
  -moz-user-select: none;
  /*火狐*/
  -ms-user-select: none;
  /*IE10*/
  user-select: none;
}

/*禁止复制*/
.no-copy {
  -webkit-touch-callout: none;
  /*系统默认菜单被禁用*/
  -webkit-user-select: none;
  /*webkit浏览器*/
  -khtml-user-select: none;
  /*早期浏览器*/
  -moz-user-select: none;
  /*火狐*/
  -ms-user-select: none;
  /*IE10*/
  user-select: none;
}

:focus {
  outline: none;
}



/* loading */
.loading {
  display: table;
  margin: 20px auto;
}

.loadng p {
  text-align: center;
}

.loading p img {
  width: 120px;
  display: block;
  margin: 5px auto;
}

.loading p {
  color: #666;
  font-size: 0.95em;
}

.hide {
  display: none;
}

.logo img {
  width: 160rem;
  padding: 10rem 0 5rem 50rem;
}

.banner img {
  width: 100%;
  display: block;
}

.content {
  text-align: center;
}

.box {
  padding: 40rem 30rem 0 30rem;
}

.margin-bottom {
  margin-bottom: 50rem;
}


.title {
  color: #222;
  padding-top: 50rem;
}

.title-en {
  font-size: 25.5rem;
}

.title-en i {
  padding: 0 8rem;
}

.title-en i:first-child {
  padding-left: 0;
}

.title-cn {
  padding-top: 5rem;
  font-size: 26rem;
  letter-spacing: 21rem;
  padding-left: 5rem;
}

.text {
  font-size: 30rem;
  padding-top: 100rem;
  padding-bottom: 40rem;
  color: #007bc4;
}

.hint {
  font-size: 26rem;
  color: #666;
  letter-spacing: 5rem;
}

.hint p:last-child {
  letter-spacing: 9.5rem;
}

.anti-fake-input {
  padding-top: 40rem;
  padding-bottom: 25rem;
}

.anti-fake-input input {
  width: 650rem;
  height: 80rem;
  font-size: 32rem;
  text-align: center;
  border: 6rem solid rgba(0, 0, 0, 0.05);
  border-top: 6rem solid rgba(0, 0, 0, 0.2);
  border-left: 6rem solid rgba(0, 0, 0, 0.2);
}

.anti-fake-button {
  padding-top: 30rem;
  padding-bottom: 50rem;
}

.anti-fake-button button {
  width: 680rem;
  height: 95rem;
  color: #FFF;
  font-size: 32rem;
  border-radius: 100rem;
  border: 4rem solid #7db74e;
  font-family: Arial, Helvetica, sans-serif;
  text-shadow: 3rem 3rem 8rem rgba(0, 0, 0, .3);
  box-shadow: 0 0 10rem rgba(0, 0, 0, .3);
  background-image: linear-gradient(#b5ea8c, #7bd13d);
}

.anti-fake-button i {
  padding-right: 15rem;
}


.return-box {
  padding: 30rem 30rem 50rem 30rem;
  margin-top: 20rem;
  background-color: #e5f9d5;
}

.return-title,
.error-title {
  padding-top: 35rem;
  display: table;
  margin: 0 auto;
  font-size: 30rem;
  line-height: 100rem;
  font-weight: bold;
}

.return-title img,
.error-title img {
  width: 60rem;
  position: relative;
  top: 15rem;
  padding-right: 10rem;
}

.return-text {
  color: #222;
  font-size: 29rem;
  line-height: 45rem;
  padding-top: 50rem;
}

.text-top {
  padding-top: 0 !important;
}

.error-box {
  padding: 10rem 30rem 30rem 30rem;
  background-color: #e8e8e8;
}

.error-title {
  padding-bottom: 15rem;
  font-size: 30rem;
  color: #c41b28;
}

.error-text {
  padding-top: 40rem;
  font-size: 29rem;
  line-height: 45rem;
  color: #333;
}

.error-text i {
  color: #c41b28;
  padding: 0 10rem;
  font-weight: bold;
}

.error-text strong {
  color: #000;
}

.text-padding i {
  padding: 0 !important;
}

.nav-box {
  display: flex;
  padding: 20rem 0;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
}

.nav-list {
  width: 33%;
  color: #444;
  font-size: 25rem;
  text-align: center;
  padding: 20rem;
  border-radius: 20rem;
}

.nav-list:active {
  background: rgba(0, 0, 0, 0.03);
}

.nav-list-img img {
  width: 100rem;
  display: block;
  margin: 0 auto;
}

.nav-list-title {
  padding-top: 12rem;
}

.nav-list-text {
  padding-top: 2rem;
}


.record-title {
  color: #FFF;
  font-size: 27rem;
  text-align: center;
  line-height: 75rem;
  background-image: linear-gradient(#3fa4ef, #79b7eb);
}

.record-img {
  padding: 20rem 0;
}

.record-img img {
  width: 100%;
  display: block;
}

.record-box ul {
  display: flex;
}

.record-box ul li {
  width: 50%;
  padding: 15rem 20rem;
  color: #444;
  font-size: 26rem;
  line-height: 35rem;
}

.record-key {
  background-color: #c2dff0;
  border-right: 2rem solid #b3d8ee;
  border-bottom: 2rem solid #b3d8ee;
}

.record-value {
  background-color: #d8e8f0;
  border-bottom: 2rem solid #c1e0ef;
}


.record-many-box {
  display: flex;
}

.record-many-box li {
  width: 33.33%;
  text-align: center;
  padding: 20rem;
  font-size: 26rem;
  line-height: 35rem;
}

.record-many-box:nth-child(1) {
  color: #FFF;
  background-image: linear-gradient(#3ca4f0, #7bb7eb);
}

.record-many-box:nth-child(2) {
  color: #444;
  background-color: #c2dff0;
}

.record-many-box:nth-child(3) {
  color: #444;
  background-color: #d8e8f0;
}

.record-footer {
  text-align: center;
  padding: 20rem;
  color: #fff;
  font-size: 28rem;
  line-height: 35rem;
  background-image: linear-gradient(#3ca4f0, #79b9e7);
}

.record-many-page {
  display: table;
  margin: 0 auto;
  margin-top: 30rem;
  overflow: hidden;
}

.record-many-page li {
  float: left;
  height: 60rem;
  width: 60rem;
  line-height: 60rem;
  text-align: center;
}

.record-many-page li:active {
  opacity: 0.9;
}

.record-many-page li:nth-child(1) {
  color: #FFF;
  font-size: 30rem;
  border: 4rem solid #5c9bf7;
  background-color: #5c9bf7;
}

.record-many-page li:nth-child(2) {
  font-size: 28rem;
  margin: 0 20rem;
  border: 4rem solid #5c9bf7;
  background-color: #ececec;
}

.record-many-page li:nth-child(3) {
  color: #FFF;
  font-size: 30rem;
  border: 4rem solid #5c9bf7;
  background-color: #5c9bf7;
}


.company-info {
  padding-bottom: 50rem;
  background-color: #e8e8e8;
}

.company-info ul {
  padding-left: 150rem;
  position: relative;
}

.company-icon {
  width: 65rem;
  display: block;
  position: absolute;
  left: 30rem;
  top: 52rem;
}

.company-title {
  font-size: 28rem;
  font-weight: bold;
  padding-top: 50rem;
  color: #444;
}

.company-text {
  padding-top: 10rem;
  font-size: 28rem;
  color: #555;
  line-height: 40rem;
}


footer {
  margin-top: 80rem;
  padding: 30rem 0;
  color: #FFF;
  font-size: 24rem;
  text-align: center;
  background-image: linear-gradient(#49aeef, #246fb8);
}

.footer-logo img {
  width: 200rem;
  display: table;
  margin: 0 auto;
}

.footer-company {
  padding-top: 10rem;
  color: white;
  display: block;
  text-decoration: none;
}

// $themeColor: #beda9f;
// $themeColorTwo: #a4cb79;
$themeColor: #f0bc93;
$themeColorTwo: #eaa168;
.daxiong{
  .record-title {
    background-image: linear-gradient(#eaa168, #f0bc93);
  }
  .record-many-box:nth-child(1) {
    background-image: linear-gradient($themeColorTwo, $themeColor);
  }
  .record-many-page li:nth-child(1) {
    border: 4rem solid $themeColor;
    background-color: $themeColor;
  }

  .record-many-page li:nth-child(2) {
    border: 4rem solid $themeColor;
    background-color: #fdede0;
  }

  .record-many-page li:nth-child(3) {
    border: 4rem solid $themeColor;
    background-color: $themeColor;
  }
  .record-footer {
    background-image: linear-gradient($themeColorTwo, $themeColor);
  }

  footer {
    background-image: linear-gradient($themeColor, $themeColorTwo);
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Normal20.vue